export const URL_GOOGLE_GROUP="https://groups.google.com/g/trivia_online";